module.exports = __webpack_public_path__ + "media/images/raidbots-logo-head-922d63f5.svg";